import { render } from "./admin.template.html?vue&type=template&id=3b1f84cb&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"

import "./Admin.vue?vue&type=style&index=0&id=3b1f84cb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b1f84cb"

export default script